import GlobalContext from './wrappers/GlobalContext';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import Result from './pages/Results';
import { createTheme, ThemeProvider } from '@mui/material';
import { ptBR } from '@mui/x-data-grid';
import { ptBR as corePtBr } from '@mui/material/locale';
import Login from './pages/Login';
import Fail from './pages/Fail';
import ResultsOverprice from './pages/ResultsOverprice';
import PrivateRoute from './wrappers/PrivateRoute';


const theme = createTheme(
  {
    palette: {
      primary: { main: '#00617b', contrastText: "#fff" },
      secondary: { main: '#ef7d00' },

    },

    typography: {
      "fontSize": 12,
      "fontWeightLight": 300,
      "fontWeightRegular": 400,
      "fontWeightMedium": 500
    }
  },
  corePtBr,
  ptBR
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalContext>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/fail" element={<Fail />} />
            <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
            <Route path="/result" element={<PrivateRoute><Result /></PrivateRoute>} />
            <Route path="/ResultOverprice" element={<PrivateRoute><ResultsOverprice /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
      </GlobalContext>
    </ThemeProvider>
  );
}

export default App;
